import React from 'react';
import { Header } from './Header';
import { TopNav } from './TopNav';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background text-on-background">
      <div className="sticky top-0 z-50">
        <Header />
        <TopNav />
      </div>
      {location.pathname === '/coach' ? (
        <main style={{ height: 'calc(100vh - 128px)' }} className="flex flex-col overflow-hidden">
          {children}
        </main>
      ) : (
        <main className="flex-1 px-4 py-6">
          <div className="mx-auto max-w-4xl">
            {children}
          </div>
        </main>
      )}
    </div>
  );
}
